import fees from "../../assets/fees.svg";
import customer from "../../assets/customer.svg";
import tenant from "../../assets/tenant.svg";
import {
  Feed,
  FeedCard,
  FeedCards,
  FeedContainer,
  FeedPost,
  FeedSection,
  FeedTitle,
  MiniCard,
  MiniCardsContainer,
  MiniNav,
  MoveInContainer,
  MoveInHeader,
} from "./MoveIn.styled";
import { NavLink } from "./../FAQ/FAQ.styled";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowDownSharpIcon from "@mui/icons-material/KeyboardArrowDownSharp";
import VerticalAlignBottomSharpIcon from "@mui/icons-material/VerticalAlignBottomSharp";
import pdfIcon from "../../assets/PdfIcon.svg";
import process from "../../assets/processTime.svg";
import todo from "../../assets/todo.svg";
import { useNavigate } from "react-router-dom";
import General from '../../stores/GeneralStore'

const MoveIn = () => {
  const navigate = useNavigate()
  return (
    <>
      <MoveInHeader>
        <div style={{ width: "90%", margin: "0 auto" }}>
          <MiniNav>
            <NavLink to="/">
              {General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : "home"}
            </NavLink>&nbsp;/&nbsp;
            <NavLink to="/">
              {General?.codeLabels["cm_mob_aboutus"]?.label !== undefined ? General?.codeLabels["cm_mob_aboutus"]?.label : "About Us"}
            </NavLink>&nbsp;/&nbsp;
            <NavLink to="/">
              Our Team

            </NavLink>
          </MiniNav>
          <h1>Move-in ( Tenancy Registration )</h1>
        </div>
      </MoveInHeader>
      <MoveInContainer>
        <MiniCardsContainer>
          <MiniCard style={{ background: "#101e8e", color: "white" }}>
            <span
              style={{ display: "flex", alignItems: "center", gap: ".4rem" }}
            >
              <img src={tenant} alt="tenant" />I am A Tenant
            </span>
            <KeyboardArrowDownSharpIcon />
          </MiniCard>
          <MiniCard>
            Pay Bill
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Move In (Tenancy Registration)
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Move Out (Service Termination)
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Apply for NOC (For Tenants)
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Request for Refund
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Request for Payment Plan Facility
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Request for Billing Details / History
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            Submit Forms
            <NavigateNextIcon />
          </MiniCard>
          <MiniCard>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: ".2rem",
              }}
            >
              <img src={pdfIcon} alt="pdf" />
              Download Service Guide 2022
            </span>
            <span>
              <p style={{ color: "#757575" }}>2 MB</p>
              <VerticalAlignBottomSharpIcon sx={{ color: "#62AA51" }} />
            </span>
          </MiniCard>
        </MiniCardsContainer>
        <FeedContainer>
          <p style={{ color: "#101E8E" }}>
            Tenant’s new account registration as a user for the property,
            activate sewerage services and record customer information in the
            system database, to enable receive monthly bill thru email and SMS
            (if the email address and the mobile number are provided)
          </p>
          <FeedTitle>
            <span>
              <img src={process} alt="process" />
              Processing Time: 1 Working Day
            </span>
            <button onClick={() => navigate('/login')}>LOGIN TO APPLY</button>
          </FeedTitle>
          <FeedSection>
            <Feed>
              <FeedPost>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    width: "100%",
                  }}
                >
                  <p>
                    <b>Service Category</b>
                    <br />
                    Subsidiary
                  </p>
                  <p>
                    <b>
                      {General?.codeLabels["cm_mob_servicetype"]?.label !== undefined ? General?.codeLabels["cm_mob_servicetype"]?.label : "Service Type"}

                    </b>
                    <br />
                    Procedural
                  </p>
                </div>
                <span>
                  ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
                </span>
                <div>
                  <b>Service Pre-requirements</b>
                  <ul>
                    <li style={{ fontSize: ".8rem" }}>
                      Property must be occupied by the Tenant
                    </li>
                    <li style={{ fontSize: ".8rem" }}>
                      Tenant To register and open new account prior to move-in;
                      failure to register will result in continued billing of
                      service to owner's account
                    </li>
                  </ul>
                </div>
              </FeedPost>
              <FeedPost>
                <h4>Video Tutorial</h4>
                <iframe
                  src="https://www.youtube.com/embed/28bs3e122lA?controls=1"
                  height={"420px"}
                  width={"100%"}
                  frameBorder={"none"}
                  title="unique"
                ></iframe>
              </FeedPost>
              <FeedPost>
                <p>
                  <b>Service Limitation</b>
                  <ul>
                    <li>Service Applied only for Tenant</li>
                    <li>
                      Valid Tenancy Contract – At least one month duration
                    </li>
                    <li>
                      Application will not be proceeded if the Tenant Emirates
                      ID or Trade License, expired / no proof of renewal
                      application
                    </li>
                    <li>
                      Application will not be processed if the property is
                      vacant
                    </li>
                  </ul>
                </p>
                <span>
                  ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
                </span>
                <p>
                  <b>Service Delivery Channels</b>
                  <p>Ajman Sewerage Website or Mobile App</p>
                </p>
                <span>
                  ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
                </span>
                <p>
                  <b>Number Of Steps / Duration</b>
                  <p>
                    Approval of documents submitted through Ajman Sewerage
                    Website and Ajman Sewerage Smart App, followed by service
                    activation - within 1 working day.
                  </p>
                </p>
                <span>
                  ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
                </span>
                <p>
                  <b>Service Application Timing</b>
                  <p>24/7 through Ajman Sewerage Website and Mobile App</p>
                </p>
              </FeedPost>
            </Feed>
            <FeedCards>
              <FeedCard>
                <span>
                  <img src={todo} alt="todo" />
                  <b style={{ fontSize: ".9rem" }}>
                    {General?.codeLabels["cm_nocmandatoryattachments"]?.label !== undefined ? General?.codeLabels["cm_nocmandatoryattachments"]?.label : " Required Documents"}

                  </b>
                </span>
                <span>---- ---- ---- ---- ---- ---- ---- ---- ---- ---</span>
                <span>
                  Valid Tenancy Contract (At least one month duration)
                </span>
                <span>Emirates ID - Residential</span>
                <span>Trade License - Commercial</span>
              </FeedCard>
              <FeedCard>
                <span>
                  <img src={fees} alt="fees" />
                  <b style={{ fontSize: ".9rem" }}>
                    {General?.codeLabels["cm_nocf_svce"]?.label !== undefined ? General?.codeLabels["cm_nocf_svce"]?.label : "Service Fees"}
                  </b>
                </span>
                <span>---- ---- ---- ---- ---- ---- ---- ---- ---- ---</span>
                <span>Free Of Charge</span>
              </FeedCard>
              <FeedCard>
                <span>
                  <img src={customer} alt="customer" />
                  <b style={{ fontSize: ".9rem" }}>Customer Segments</b>
                </span>
                <span>---- ---- ---- ---- ---- ---- ---- ---- ---- ---</span>
                <span>
                  {General?.codeLabels["cm_nocpropertytyperesidential"]?.label !== undefined ? General?.codeLabels["cm_nocpropertytyperesidential"]?.label : "Residential"}
                </span>
                <span>
                  {General?.codeLabels["cm_nocpropertytypecommercial"]?.label !== undefined ? General?.codeLabels["cm_nocpropertytypecommercial"]?.label : "Commercial"}

                </span>
                <span>Industrial</span>
              </FeedCard>
            </FeedCards>
          </FeedSection>
        </FeedContainer>
      </MoveInContainer>
    </>
  );
};

export default MoveIn;
